var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer",attrs:{"disabled":_vm.validateDisabled,"vid":_vm.validateVid,"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var dirty = ref.dirty;
var pristine = ref.pristine;
var valid = ref.valid;
var invalid = ref.invalid;
var pending = ref.pending;
var touched = ref.touched;
var untouched = ref.untouched;
var passed = ref.passed;
var failed = ref.failed;
var errors = ref.errors;
var validate = ref.validate;
var validateWithInfo = ref.validateWithInfo;
var handleSubmit = ref.handleSubmit;
var reset = ref.reset;
return [_c('b-form',_vm._b({on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},'b-form',_vm.$attrs,false),[_vm._t("default",null,null,{ dirty: dirty, pristine: pristine, valid: valid, invalid: invalid, pending: pending, touched: touched, untouched: untouched, passed: passed, failed: failed, errors: errors, validate: validate, validateWithInfo: validateWithInfo, handleSubmit: handleSubmit, reset: reset })],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }